import {availableCountries} from '@vio/core/src/localization/business/countries'

/**
 * Countries `availableCountries` maps to USD despite having their own currency.
 * Corrected here rather than in core: `partners/widgetConfig` reads
 * `currencyCode` unfiltered, so fixing it there would default those widgets to
 * currencies the app cannot price in.
 *
 * Sierra Leone uses the older SLL, not SLE: SLE is missing from
 * `ALL_CURRENCIES`, so the UI could not render it.
 */
const CARD_CURRENCY_OVERRIDES: Record<string, string> = {
  CD: 'CDF',
  CG: 'XAF',
  CI: 'XOF',
  DJ: 'DJF',
  DZ: 'DZD',
  ER: 'ERN',
  FK: 'FKP',
  GH: 'GHS',
  GN: 'GNF',
  GW: 'XOF',
  HT: 'HTG',
  KE: 'KES',
  KG: 'KGS',
  KM: 'KMF',
  MR: 'MRU',
  MU: 'MUR',
  MV: 'MVR',
  MW: 'MWK',
  MZ: 'MZN',
  NG: 'NGN',
  PG: 'PGK',
  PS: 'ILS',
  SC: 'SCR',
  SD: 'SDG',
  SL: 'SLL',
  SO: 'SOS',
  SS: 'SSP',
  ST: 'STN',
  SZ: 'SZL',
  TJ: 'TJS',
  TO: 'TOP',
  UG: 'UGX',
  UZ: 'UZS',
  ZM: 'ZMW'
}

/**
 * [PICC] The currency a card issued in `countryCode` is denominated in.
 *
 * Not `getCountryAttribute`: it falls back to US (so USD) for unknown codes, and
 * an unknown country must mean "no choice", not "assume USD".
 */
export const getCardCurrency = (countryCode: string): string | undefined =>
  CARD_CURRENCY_OVERRIDES[countryCode] ??
  availableCountries[countryCode]?.currencyCode
